var map = {
	"./0.txt": 3780,
	"./1.txt": 2702,
	"./10.txt": 8285,
	"./11.txt": 79,
	"./12.txt": 4271,
	"./13.txt": 2463,
	"./14.txt": 3947,
	"./15.txt": 9677,
	"./16.txt": 5206,
	"./17.txt": 930,
	"./18.txt": 7232,
	"./19.txt": 3829,
	"./2.txt": 7892,
	"./3.txt": 6116,
	"./4.txt": 5412,
	"./5.txt": 2696,
	"./6.txt": 3476,
	"./7.txt": 3956,
	"./8.txt": 3306,
	"./9.txt": 8844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 445;